import { useSnapshot } from "valtio";
import off from "../../components/off.png";
import on from "../../components/on2.png";
import { configStore, creditformStore, EntityV2Store, loginStore } from "../../state/CommonState";
import { ReactComponent as Loader } from "../../assets/loader.svg"
import { useState } from "react";
import CreditsApis from "../../state/credit-api";
import EntityV2Api from "../../state/entities-api";
import TenantUtils from "../../util/tenant.utils";
import EntityApi from "../../state/entity-api";
// import EntityApi from "../../state/entity-api";

export default function Creditcontrol (fn) {
    // let CreditForm = creditformStore.CreditformRec
    const Entity = EntityV2Store.EntityRec;
    useSnapshot(EntityV2Store)
    const [loading , setLoading] = useState(false)

    const handleSubmitSave = async () => {
        if(Entity.creditControl.remarks?.trim().length < 3 || !Entity.creditControl.remarks){
            return   configStore.setModalMessage('Remarks is required and it should contain atleast 3 letters', [], true)
        }
        if(!Array.isArray(Entity.creditControl.timeline )){
           Entity.creditControl.timeline = []     
        }
        Entity.creditControl.timeline.push({
            date: Date.now(),
            event: "Credit Controls Enabled",
            user: loginStore.email,
            // role: RoleUtils.getUserRole(),
        })
        await EntityV2Api.updateEntityCreditControl(Entity?.entityId, Entity?.creditControl, (data) => {
            EntityApi.getCreditControl()

            configStore.setModalMessage('Credit Control restrictions enabled.', [], true)
            fn.fn(false)

        },);
    }

    const timelineIndex = Entity.creditControl.timeline?.length - 1
    return <>
     <div className="box">
            <h1 className="title is-flex is-align-items-center p-1"> 
                <span>Credit Control</span>
                <button
                    onClick={async (e) => {
                        e.preventDefault()
                        fn.fn(false)
                    }}
                    className="delete is-large is-info "
                    style={{ backgroundColor: "#485fc7", marginLeft: "78%" }}
                ></button>
            </h1>
            <div style={{ paddingLeft : "10%"}} >
             <div className="is-flex is-align-items-center" >
                <span style={{width : "25%"}}><label className="is-size-5 ">Enable Restrictions</label></span>
                    <button
                        className="is-clickable ml-4"
                        type="button"
                        style={{ border: "none", backgroundColor: "white" }}
                        onClick={() => { Entity.creditControl.enableRestriction = !Entity?.creditControl?.enableRestriction }}
                    >
                        {Entity?.creditControl?.enableRestriction ? (
                            <img height="20px" width="36px" src={on}></img>
                        ) : (
                            <img height="20px" width="36px" src={off}></img>
                        )}
                    </button>
             </div>
                {Entity.creditControl.enableRestriction && <>
                    <div className="is-flex is-align-items-center" >
                        <span style={{ width: "25%" }}><label className="is-size-5 ">Disable Enquiry & Quotation</label></span>
                        <button
                            className="is-clickable ml-4"
                            type="button"
                            style={{ border: "none", backgroundColor: "white" }}
                            onClick={() => { Entity.creditControl.blockEnquiry = !Entity?.creditControl?.blockEnquiry }}
                        >
                            {Entity?.creditControl?.blockEnquiry ? (
                                <img height="20px" width="36px" src={on}></img>
                            ) : (
                                <img height="20px" width="36px" src={off}></img>
                            )}
                        </button>
                    </div>
                    <div className="mt-4" >
                        <div><span style={{ width: "25%" }}><label className="is-size-5  has-text-weight-semibold">Disable Bookings</label></span></div>
                        <div className="is-flex is-align-items-center " style={{ marginLeft: "10%" }}>
                            <div className="is-flex is-align-items-center ">
                                <span><label className="is-size-6 ">LCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.blockBookingCreation.lcl = !Entity?.creditControl?.blockBookingCreation.lcl }}
                                >
                                    {Entity?.creditControl?.blockBookingCreation.lcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4 ">FCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.blockBookingCreation.fcl = !Entity?.creditControl?.blockBookingCreation.fcl }}
                                >
                                    {Entity?.creditControl?.blockBookingCreation.fcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4">AIR</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.blockBookingCreation.air = !Entity?.creditControl?.blockBookingCreation.air }}
                                >
                                    {Entity?.creditControl?.blockBookingCreation.air ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                        </div>

                    </div>

                    <div className="mt-4">
                        <div><span style={{ width: "25%" }}><label className="is-size-5 has-text-weight-semibold">Prompt for Cargo Hold at Origin</label></span></div>
                        <div className="is-flex is-align-items-center " style={{ marginLeft: "10%" }}>
                            <div className="is-flex is-align-items-center ">
                                <span><label className="is-size-6 ">LCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdCargoOrgin.lcl = !Entity?.creditControl?.holdCargoOrgin.lcl }}
                                >
                                    {Entity?.creditControl?.holdCargoOrgin.lcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4 ">FCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdCargoOrgin.fcl = !Entity?.creditControl?.holdCargoOrgin.fcl }}
                                >
                                    {Entity?.creditControl?.holdCargoOrgin.fcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4">AIR</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdCargoOrgin.air = !Entity?.creditControl?.holdCargoOrgin.air }}
                                >
                                    {Entity?.creditControl?.holdCargoOrgin.air ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                        </div>

                    </div>

                    <div className="mt-4">
                        <div><span style={{ width: "25%" }}><label className="is-size-5 has-text-weight-semibold">Prompt for Hold BL/DO</label></span></div>
                        <div className="is-flex is-align-items-center " style={{ marginLeft: "10%" }}>
                            <div className="is-flex is-align-items-center ">
                                <span><label className="is-size-6 ">LCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdBLDO.lcl = !Entity?.creditControl?.holdBLDO.lcl }}
                                >
                                    {Entity?.creditControl?.holdBLDO.lcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4 ">FCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdBLDO.fcl = !Entity?.creditControl?.holdBLDO.fcl }}
                                >
                                    {Entity?.creditControl?.holdBLDO.fcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4">AIR</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdBLDO.air = !Entity?.creditControl?.holdBLDO.air }}
                                >
                                    {Entity?.creditControl?.holdBLDO.air ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                        </div>

                    </div>

                    <div className="mt-4" >
                        <div><span style={{ width: "25%" }}><label className="is-size-5 has-text-weight-semibold">Prompt for Hold Delivery</label></span></div>
                        <div className="is-flex is-align-items-center " style={{ marginLeft: "10%" }}>
                            <div className="is-flex is-align-items-center ">
                                <span><label className="is-size-6 ">LCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdDelivery.lcl = !Entity?.creditControl?.holdDelivery.lcl }}
                                >
                                    {Entity?.creditControl?.holdDelivery.lcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4 ">FCL</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdDelivery.fcl = !Entity?.creditControl?.holdDelivery.fcl }}
                                >
                                    {Entity?.creditControl?.holdDelivery.fcl ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                            <div>
                                <span><label className="is-size-6 ml-4">AIR</label></span>
                                <button
                                    className="is-clickable ml-4"
                                    type="button"
                                    style={{ border: "none", backgroundColor: "white" }}
                                    onClick={() => { Entity.creditControl.holdDelivery.air = !Entity?.creditControl?.holdDelivery.air }}
                                >
                                    {Entity?.creditControl?.holdDelivery.air ? (
                                        <img height="20px" width="36px" src={on}></img>
                                    ) : (
                                        <img height="20px" width="36px" src={off}></img>
                                    )}
                                </button>
                            </div>
                        </div>

                    </div>
                      <div className="mt-6" >
                        <div><span style={{ width: "25%" }}><label className="is-size-5 has-text-weight-semibold">Remarks</label></span></div>  
                        <textarea  style={{ width : "55%" , height : "70px" , padding : "0.2%"}} value ={Entity.creditControl.remarks} onChange={(e) => Entity.creditControl.remarks = e.target.value }></textarea>   
                    </div>
                      <div>
                    <button
                        className="button_submit"
                        style={{ marginLeft : "85%"}}
                        type="submit"
                        onClick={handleSubmitSave}
                        disabled={loading}
                    >
                        {!loading ? "SAVE" : <Loader className="spinner" />}
                    </button>
                        { Entity.creditControl?.timeline?.length > 0 &&
                            <div>
                                <p>Note : Last updated by {Entity.creditControl.timeline[timelineIndex]?.user} on {new Date(Entity.creditControl.timeline[timelineIndex]?.date).toLocaleString()}  </p>
                            </div>
                        }
                </div> 
                </>}              
            </div>
     </div>
    </>
}